import { http } from "./http"
import type { MediaType } from "models/mediaType"
import type { Paginated } from "./types"
import type { Dictionary } from "utils/types"
import { MediaType as MediaConfigType } from "routes/Base/Admin/GlobalMediaTypes/types"

export const fetchMediaTypes = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http("media-types", { searchParams }).json()
  return res as Paginated<MediaType>
}

export const fetchMediaConfig = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = (await http("media-config", {
    searchParams,
  }).json()) as Paginated<MediaConfigType>
  return res
}

export type MediaPreference = {
  mediaFieldSemanticCode: string
  order: number
  visible: boolean
  width?: number
}

export const fetchMediaPreferences = async (_key: string, params?: string) => {
  const searchParams = new URLSearchParams(params)
  const res = await http("preferences/columns", { searchParams }).json()
  return res as Dictionary<MediaPreference[]>
}

export const updateMediaPreferences = async (pld: {
  clientId: string
  agencyId: string
  payload: Dictionary<MediaPreference[]>
}) => {
  const { clientId, agencyId, payload } = pld
  const searchParams = new URLSearchParams()
  searchParams.set("clientId", clientId)
  searchParams.set("agencyId", agencyId)

  const res = await http
    .post("preferences/columns", { searchParams, json: payload })
    .json()

  return res as any
}
